<template>
    <div v-if="data">
        <errors :errors="errors"/>

        <component
            :is="data.component"
            :data="data"
            :class-id="classId"
            v-model="dataModel"/>

        <additional-info
            v-model="dataModel"
            :allow-conclusion="false"
            :allowImages="data.value !== REPORT_TYPE.BATHROOM"/>
    </div>
</template>

<script>
import Errors from "../atoms/Errors.vue";
import AdditionalInfo from "../molecules/AdditionalInfo.vue";
import {REPORT_TYPE} from "../../../services/Defaults";
import axios from "axios";

export default {
    name: "DailyReportForm",
    components: {AdditionalInfo, Errors},
    props: {
        data: {
            type: Object,
            required: true
        },
        childrenIds: {
            type: Array,
            required: true
        },
        classId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            REPORT_TYPE,
            dataModel: {
                model: this.data.value,
            },
            errors: [],
        };
    },
    watch: {
        dataModel: {
            handler() {
                this.errors = [];
            },
            deep: true,
        }
    },
    methods: {
        submit() {
            const formData = new FormData();

            Object.keys(this.dataModel).forEach(key => {
                if (key !== 'images' && this.dataModel[key] !== null) {
                    formData.append(key, this.dataModel[key]);
                }
            });

            this.dataModel.images?.forEach((image, index) => {
                formData.append(`images[${index}]`, image);
            });

            this.childrenIds.forEach((childId, index) => {
                formData.append(`children_ids[${index}]`, childId);
            });

            axios.post('/child-report/new', formData)
                .then(response => {
                    this.$emit('submit', {status: 'success', data: response.data.data});
                    this.$notify({
                        type: 'success',
                        text: trans('general.module.report.messages.updated_message', {attribute: this.childrenIds.length})
                    });
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errors = Object.values(error.response.data.errors).flat();
                    } else {
                        this.errors = [error.message || 'An error occurred'];
                    }

                    this.$emit('submit', { status: 'error', error: error });
                });
        }
    },
};
</script>

<style>
@media (max-width: 991px) {
    .modal-fullscreen-lg-down .modal-content {
        height: 100dvh;
    }
}
</style>
